import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=a67861b6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67861b6')) {
      api.createRecord('a67861b6', component.options)
    } else {
      api.reload('a67861b6', component.options)
    }
    module.hot.accept("./permission.vue?vue&type=template&id=a67861b6&", function () {
      api.rerender('a67861b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/permission.vue"
export default component.exports